module.exports = __webpack_public_path__ + "static/media/4_citric_candy_small.860dee9a.jpg";